module.exports = __webpack_public_path__ + "img/Big Picture Thinker.4639c11f.svg";